import { ApolloLink } from '@apollo/client';
import omitDeep from 'omit-deep-lodash';
export const removeTypenameFromMutation = (operation, forward) => {
  var _operation$query;
  const definition = operation === null || operation === void 0 || (_operation$query = operation.query) === null || _operation$query === void 0 || (_operation$query = _operation$query.definitions.filter(def => def.kind === 'OperationDefinition')) === null || _operation$query === void 0 ? void 0 : _operation$query[0];
  const mutation = 'mutation';
  if ((definition === null || definition === void 0 ? void 0 : definition.kind) == 'OperationDefinition' && (definition === null || definition === void 0 ? void 0 : definition.operation) === mutation) {
    operation.variables = omitDeep(operation.variables, '__typename');
    return forward(operation);
  }
  return forward(operation);
};
export const removeTypenameFromMutationLink = new ApolloLink(removeTypenameFromMutation);